<template>
  <f7-page class="main-frm-expedition-sales-receipt">
    <f7-navbar :style="appTheme">
      <f7-nav-left>
        <f7-link
          icon="icon-custom-back"
          class="padding-left"
          @click="goBack"
        />
        <div
          class="title color-white"
        >
          {{ $t('commercialization.common.deliveryNotesSummary') }}
        </div>
      </f7-nav-left>
    </f7-navbar>
    <div class="albaranes-container">
      <div
        v-for="albaran in albaranesVenta"
        :key="albaran.Id"
        class="albaranes-container__albaran"
        @click="SalesReceiptSelected(albaran)"
      >
        <div class="lateral">
          {{ $t('common.deliveryNote').toUpperCase() }}
        </div>
        <div class="contenido">
          <span class="contenido__nombre">{{ albaran.NombreCliente }}</span>
          <span>{{ `${albaran.Serie} / ${albaran.Numero}` }}</span>
          <span>{{ `${$t('common.referenceShort')}: ${albaran.Referencia}` }}</span>
        </div>
        <div class="flecha">
          <img src="@/static/icons/flechaDerecha.svg">
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { Log } from '@/js/common/HIDebuggingSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';
import { HiDialog } from '@/js/common/HINotificationSupport';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';

export default {
  name: 'FrmExpeditionSalesReceipt',

  props: {
    expedition: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      albaranesVenta: null,
    };
  },

  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },
  },

  created() {
    this.StartComponent();
  },
  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.GetSaleReceipts();
    },
    async goBack() {
      if (this.expedition.EstadoOrdenCarga === 2) {
        f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionDocument/', {
          ignoreCache: true,
          reloadPrevious: true,
          props: {
            expeditionDocument: this.expedition,
            reload: true,
          },
        });
        await sleep(500);
        f7.views.main.router.back();
      } else {
        f7.views.main.router.navigate('/commercialisation/expedition/frmExpedition', {
          ignoreCache: true,
          reloadPrevious: true,
          props: {
            reload: true,
          },
        });
        await sleep(500);
        f7.views.main.router.back();
      }
    },

    SalesReceiptSelected(albaran) {
      Log(this, this.SalesReceiptSelected.name);
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionSalesReceiptData', {
        props: {
          albaran,
        },
      });
    },

    async GetSaleReceipts() {
      Log(this, this.GetSaleReceipts.name);
      HiDialog.Preloader(true, this.$t('commercialization.info.loadingDeliveryNotes'), false);
      await callExecuteSPERP(
        'APPERPAGRO_AlbaranesVentaXOrdenCarga',
        [{ NombreParametro: 'Id_OrdenCarga', Valor: this.expedition.Id }],
        'Compras.AlbaranVentaJSON',
      ).then((result) => {
        this.albaranesVenta = result.data;
      });
      HiDialog.Preloader(false);
    },

  },
};
</script>

<style scoped lang="scss">
.main-frm-expedition-sales-receipt {
  .page-content {
    background-color: var(--his-tierra-white);
  }

  .albaranes-container {
    background-color: var(--his-tierra-white);
    height: calc(100vh - 60px - var(--information-bar-padding-bottom));
    overflow-y: scroll;

    &__albaran {
      border-radius: 0 10px 10px 0;
      background: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 18px;

      .lateral {
        writing-mode: vertical-rl;
        text-align: center;
        background: var(--his-oliva);
        height: 16vh;
        transform: rotate(180deg);
        border-radius: 0 10px 10px 0;
        color: var(--his-slate-blue);
      }

      .contenido {
        display: flex;
        flex-direction: column;
        margin-left: 20px;
        width: 100vw;

        span {
          margin-top: 10px;
          font-size: 18px;
          color: var(--his-slate-blue);
        }

        &__nombre {
          font-weight: bolder;
        }
      }

      .flecha {
        margin-right: 20px;
      }
    }
  }

  .btns {
    .btn-confirmar {
      background: var(--his-oliva);
    }
  }
}

/****  FIN - Estilos del Popup de selección de LPV en el UCSearch ***/
</style>
